import { Layers } from "appworks/graphics/layers/layers";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { Contract } from "appworks/utils/contracts/contract";
import { Point } from "appworks/utils/geom/point";
import { gameLayers } from "game-layers";
import Matter = require("matter-js");

export abstract class FowlAbstractObstacleSubcomponent {
    public triggered: boolean = false;
    protected spine: SpineContainer;
    protected width: number;

    constructor(
        public position: Point,
        public layer: Layers = gameLayers.FlingBonus
    ) { }

    public checkCollision(foxPosition: Point): boolean {
        if (!this.spine) { return false; }

        if (!this.triggered) {
            if (!this.width) { this.width = this.spine.spines.landscape.getBounds(true).width; }
            return this.spine.landscape.getCenterPoint().distanceTo(foxPosition) < this.width;
        }
        return false;
    }

    public onCollision(foxBody: Matter.Body) {
        this.triggered = true;
    }

    public animate(): Contract {
        return this.spine.playOnce("collision");
    }

    public destroy() {
        this.spine?.destroy();
        this.spine = null;
    }
}